import createSelector from 'web-app/util/custom-create-selector';
import {type RootState} from 'web-app/react/redux/main-reducer';

export const isShowingModals = createSelector(
    (state: RootState) => state.modals.modalsContainer.openModalsCount,
    openModalsCount => openModalsCount > 0,
);
